import React, { useState } from "react";

// import { SimpleHeadMui } from "components";
import CloseIcon from "@mui/icons-material/Close";
import { Box, BoxProps, Button, IconButton, Stack, TextField } from "@mui/material";
import Modal from "@mui/material/Modal";
import { useActionHook, useDidUpdate, useModals } from "hooks";
import { ICreateModal } from "store/types/modals";

const boxSx: BoxProps["sx"] = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "white",
  borderRadius: "10px"
};

export const CreateModal: React.FC<{ data: ICreateModal | null }> = ({ data }) => {
  const defaultAction = async () => undefined;
  const { closeCreateModal } = useModals();

  const { title, submitButtonTitle, action: initialAction, noDisable, defaultValue, label = "Name" } = data || {};
  const [inputValue, setInputValue] = useState<string>("");

  useDidUpdate(() => {
    if (!defaultValue) return;
    setInputValue(defaultValue);
  }, [defaultValue]);

  const { action, error, resetError, loading } = useActionHook(initialAction || defaultAction, {
    onSuccess: () => {
      setInputValue("");
      closeCreateModal();
    }
  });

  const onClose = () => {
    resetError();
    closeCreateModal();
  };

  const onCancel = () => {
    closeCreateModal();
    setInputValue("");
    resetError();
  };

  const isSubmitDisabled = loading || (noDisable ? !noDisable : !inputValue);

  const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (isSubmitDisabled) return;
    action(inputValue);
  };

  return (
    <Modal open={!!data} onClose={onClose}>
      <Box sx={boxSx}>
        <Box sx={{ background: "#fff", borderRadius: "10px 10px 0px 0px", padding: "30px 30px 0 30px" }}>
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            sx={{ borderBottom: "1px solid  #DAE0E2", paddingBottom: "5px" }}
          >
            <span>{title ? title : "CREATE ELEMENT"}</span>
            <IconButton onClick={onClose}>
              <CloseIcon className="icon" />
            </IconButton>
          </Stack>
        </Box>
        <Stack component="form" onSubmit={onSubmit} alignItems="stretch" sx={{ p: "20px 30px 30px 30px" }}>
          <TextField
            placeholder={data?.inputPlaceholder ? data?.inputPlaceholder : ""}
            value={inputValue}
            autoFocus
            onChange={(event) => setInputValue(event.target.value)}
            error={!!error?.errors?.title || !!error?.errors?.name}
            helperText={error?.errors?.title || error?.errors?.name}
            sx={{
              width: "400px",
              "& .MuiOutlinedInput-input": {
                padding: "12px 10px"
              }
            }}
            size="medium"
            label={label}
            fullWidth={false}
          />
          <Stack sx={{ mt: "30px" }} direction="row" justifyContent="flex-end" gap="20px">
            <Button type="button" variant="outlined" onClick={onCancel}>
              Cancel
            </Button>
            <Button type="submit" variant="contained" disabled={isSubmitDisabled}>
              {submitButtonTitle ? submitButtonTitle : "Add"}
            </Button>
          </Stack>
        </Stack>
      </Box>
    </Modal>
  );
};
